import { Link } from 'react-router-dom';
import * as enums from '../../enums';
import cx from 'classnames';
import s from './styles.scss';
import { ButtonLinkProps } from './types';

export const ButtonLink = ({
  children,
  className,
  variant = enums.Variant.DEFAULT,
  color = enums.ColorTheme.PRIMARY,
  size = enums.Size.MEDIUM,
  disabled = false,
  hasError = false,
  to,
  onClick,
}: ButtonLinkProps): JSX.Element => {
  const buttonCx = cx(
    s.button,
    s[size],
    s[variant],
    s[color],
    { [s.disabled]: disabled },
    { [s.error]: hasError },
    className
  );

  return (
    <Link
      role="button"
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : 0}
      className={buttonCx}
      to={to}
      onClick={onClick}
    >
      {children}
    </Link>
  );
};
